module.exports = __webpack_public_path__ + "img/coin.ec08c60e.svg";